document.addEventListener('DOMContentLoaded', () => {
    const scope = document.querySelector("[data-product-finder]");
    
    if (!scope) {
        return;
    }
    
    const resultsContainer = scope.querySelector('[data-search-container]');
    const filtersContainer = scope.querySelector('[data-filters]');
    const currentPage = scope.querySelector('[data-currentPage]');
    const loadingContainer = scope.querySelector('[data-loading]');

    if (!resultsContainer) return;

    const getMakeCheckboxes = () => Array.from(filtersContainer.querySelectorAll('[data-make]'));
    const getCategoriesCheckboxes = () => Array.from(filtersContainer.querySelectorAll('[data-category]'));
    const getTypesCheckboxes = () => Array.from(filtersContainer.querySelectorAll('[data-type]'));
    const getSelectedCheckbox = (selector) => Array.from(filtersContainer.querySelectorAll(selector)).find(x => x.checked);
    const getSelectedMake = () => getSelectedCheckbox("[data-make]")?.value;
    const getSelectedCategory = () => getSelectedCheckbox("[data-category]")?.value;
    const getSelectedType = () => getSelectedCheckbox("[data-type]")?.value;

    const getSelectedLabelText = (selector) => {
        const checkbox = getSelectedCheckbox(selector);
        if (!checkbox) return null;
        const label = filtersContainer.querySelector(`label[for="${checkbox.id}"]`);
        return label ? label.textContent.trim() : null;
    };

    const MAGIC_STRING_PATTERN = /\{\{(Make|Category|Type|VehicleWord)\}\}/g;
    const TIPPER_TYPE_VALUE = 'tipper';
    const VANS_OR_VEHICLES_WORD_PATTERN = /\b(vans|vehicles)\b/gi;

    const stripVansOrVehiclesWord = (categoryText) => {
        if (!categoryText) return categoryText;
        return categoryText.replace(VANS_OR_VEHICLES_WORD_PATTERN, '').replace(/\s{2,}/g, ' ').trim();
    };

    const resolveVehicleWord = (categoryText, typeText) => {
        const make = getSelectedMake();
        const category = getSelectedCategory();
        const type = getSelectedType();

        if (!make && !category && !type) {
            return 'Vans & Cars';
        }

        const isVanCategory = (categoryText ?? '').toLowerCase().includes('vans');
        const isVanType = (typeText ?? '').toLowerCase().includes('vans');
        const isTipper = (type ?? '').toLowerCase() === TIPPER_TYPE_VALUE;

        return isVanCategory || isVanType || isTipper ? 'Vans' : 'Vehicles';
    };

    const applyMagicStringReplacements = (template) => {
        const categoryText = getSelectedLabelText("[data-category]");
        const typeText = getSelectedLabelText("[data-type]");

        const replacements = {
            Make: getSelectedLabelText("[data-make]"),
            Category: stripVansOrVehiclesWord(categoryText),
            Type: stripVansOrVehiclesWord(typeText),
            VehicleWord: resolveVehicleWord(categoryText, typeText)
        };

        return template.replace(MAGIC_STRING_PATTERN, (match, token) => replacements[token] ?? '');
    };

    const updateMagicTitles = () => {
        
        
        document.querySelectorAll('[data-magic-title-template]').forEach(el => {
            if(el.dataset.magicTitleTemplate !== '') {
                el.innerHTML = applyMagicStringReplacements(el.dataset.magicTitleTemplate);
            }
        });

        document.querySelectorAll('[data-magic-subtitle-template]').forEach(el => {
            if(el.dataset.magicSubtitleTemplate !== '') {
                el.innerHTML = applyMagicStringReplacements(el.dataset.magicSubtitleTemplate);
            }
        });
    };

    let pendingFocusId = null;

    const bindFilters = () => {
        const bindFilter = checkboxes => {
            checkboxes.forEach(field => {
                field.addEventListener('change', () => {
                    checkboxes.forEach(checkbox => {
                        if (checkbox !== field) {
                            checkbox.checked = false;
                        }
                    });

                    pendingFocusId = field.id || null;
                    performSearch();
                });
            });
        }

        bindFilter(getMakeCheckboxes());
        bindFilter(getCategoriesCheckboxes());
        bindFilter(getTypesCheckboxes());
    }
    
    const bindResults = () => {
        const ecommerceModels = Array.from(resultsContainer.querySelectorAll("[data-product-data-layer]"))
            .map(vehicleNode => JSON.parse(vehicleNode.dataset.productDataLayer));
        
        if (ecommerceModels.length) {
            const model = ecommerceModels[0];
            
            for (let i = 1; i < ecommerceModels.length; i++) {
                model.items.push(ecommerceModels[i].items[0]);
            }

            DataLayerManager.trigger(DataLayerManager.events.viewItemList, model);
        }
        
        resultsContainer.querySelectorAll("[data-product-data-layer]")
            .forEach(vehicleNode => {
                vehicleNode.querySelectorAll("a")
                    .forEach(link => {
                       link.addEventListener("click", () => {
                           const ecommerceModel = JSON.parse(vehicleNode.dataset.productDataLayer);
                           
                          DataLayerManager.trigger(DataLayerManager.events.selectItem, ecommerceModel);
                           sessionStorage.removeItem("viewedProduct");
                       });
                    });
            });
    }

    async function updateSearch(queryString, pushToHistory = true) {
        scope.querySelector('[data-results]').style.display = 'none';
        loadingContainer.style.display = 'block';

        const cleanQuery = queryString.startsWith('?') ? queryString : `?${queryString}`;
        try {
            const getSearchResults = fetch(`${scope.dataset.searchUrl}${cleanQuery}`, {
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            });
            const getFilters = fetch(`${scope.dataset.filtersUrl}${cleanQuery}`, {
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            });

            const searchResponse = await getSearchResults;
            const filtersResponse = await getFilters;
                        
            if (searchResponse.ok) {                
                resultsContainer.innerHTML = await searchResponse.text();

                ControlBinders.run(resultsContainer);
                bindResults();
                resultsContainer.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
            
            if (filtersResponse.ok) {
                const openFilterGroups = Array.from(filtersContainer.querySelectorAll('details[data-filter-group][open]'))
                    .map(details => details.dataset.filterGroup);

                filtersContainer.innerHTML = await filtersResponse.text();

                openFilterGroups.forEach(group => {
                    const details = filtersContainer.querySelector(`details[data-filter-group="${group}"]`);
                    if (details) details.open = true;
                });

                ControlBinders.run(filtersContainer);
                bindFilters();

                if (pendingFocusId) {
                    filtersContainer.querySelector(`#${pendingFocusId}`)?.focus();
                    pendingFocusId = null;
                }

                updateMagicTitles();
            }

            if (pushToHistory) {
                const urlSections = [];

                const selectedMake = getSelectedMake();
                const selectedCategory = getSelectedCategory();
                const selectedType = getSelectedType();

                if (selectedMake || selectedCategory || selectedType) {
                    urlSections.push(selectedMake || "any-make");
                }

                if (selectedCategory || selectedType) {
                    urlSections.push(selectedCategory || "any-size");
                }

                if (selectedType) {
                    urlSections.push(selectedType);
                }

                let pushStateUrl = `${scope.dataset.baseUrl}${urlSections.join('/')}`;

                const searchParams = new URLSearchParams(queryString);

                if (searchParams.has('page') && parseInt(searchParams.get("page")) > 1) {
                    pushStateUrl += `?page=${searchParams.get("page")}`;
                }

                window.history.pushState({queryString}, '', pushStateUrl);
            }
        } catch (err) {
            console.error('Search Error:', err);
        } finally {
            loadingContainer.style.display = 'none';
        }
    }

    document.addEventListener('click', (event) => {
        const button = event.target.closest('[data-pagingbutton]');
        const pagingBack = event.target.closest('[data-paging-back]');
        const pagingNext = event.target.closest('[data-paging-next]')
        if (button) {
            const pageNumber = button.getAttribute('data-pagenumber');
            performSearch(pageNumber);
        }
        if (pagingBack) {
            const pageNumber = pagingBack.getAttribute('data-pagenumber');
            performSearch(pageNumber);
        }
        if (pagingNext) {
            const pageNumber = pagingNext.getAttribute('data-pagenumber');
            performSearch(pageNumber);
        }
    });

    function performSearch(pageNumber = 1) {
        const params = new URLSearchParams();

        const addParamIfChecked = (selectedValue, paramName) => {
            if (selectedValue) {
                params.append(paramName, selectedValue);
            }
        }

        addParamIfChecked(getSelectedMake(), "Make");
        addParamIfChecked(getSelectedCategory(), "Category");
        addParamIfChecked(getSelectedType(), "Type");

        params.append("pageSize", (parseInt(resultsContainer.dataset.resultsPerPage) || 12).toString());

        if (pageNumber) {
            params.append('page', pageNumber);
        } else {
            if (currentPage?.Value) params.append('page', currentPage.Value)
        }
        updateSearch(`?${params}`);
    }

    bindFilters();
    bindResults();    
});